import CountUp from "react-countup";

const Convercoes = ({ convercoes, taxa }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Conversoes</p>
      <p className="text-2xl font-bold text-emerald-600">
        <CountUp end={convercoes} duration={1.5} />
      </p>
      <p className="text-xs text-gray-400 mt-1">
        {taxa}% dos visitantes unicos clicaram em links de contato ou localizacao.
      </p>
    </div>
  );
};

export default Convercoes;
